<template>
  <div>
    <div class="panel">
      <b-button
        v-if="mayManage"
        @click="registerNewRevisionsByAttempts()"
      >
        Register new revisions by attempts
      </b-button>

      <b-button
        v-if="mayManage"
        @click="updateCache()"
      >
        Update cache
      </b-button>
    </div>

    <p v-if="message !== null">
      {{message}}
    </p>

    <loading-indicator
      v-if="isLoading"
    />
  </div>
</template>

<script>
import auth from '../auth';
import { HTTP } from '../http-common';
import notifier from '../notifier';

import { isRoleAdmin } from '../util';

import LoadingIndicator from './LoadingIndicator.vue';

const LOAD_STATE_INIT          = 1;
const LOAD_STATE_LOADING       = 2;
const LOAD_STATE_LOADED_NORMAL = 3;
const LOAD_STATE_LOADED_ERROR  = 4;

export default {
  name: 'SystemLevelsRevisions',

  components: {
    LoadingIndicator,
  },

  data() {
    return {
      actor: auth.getViewer(),

      loadState: LOAD_STATE_INIT,
      revisions: null,
    };
  },

  computed: {
    mayManage() {
      return isRoleAdmin(this.actor.role);
    },

    isLoading() {
      return this.loadState === LOAD_STATE_LOADING;
    },

    isLoadedNormal() {
      return this.loadState === LOAD_STATE_LOADED_NORMAL;
    },

    message() {
      if(this.isLoadedNormal && this.revisions !== null && this.revisions.length === 0) {
        return 'No revisions.';
      }
      return null;
    },
  },

  created() {
    this.loadRevisions();
  },

  methods: {
    loadRevisions() {
      notifier.deleteSenderNotifications(this);

      this.loadState = LOAD_STATE_LOADING;

      const url = '/levels_revisions';
      HTTP.get(url)
      .then(response => {
        const data = response.data.data;
        if(data === null) {
          notifier.showError('Invalid server response. data === null.', {sender: this});
          return;
        }

        this.revisions = data;
        this.loadState = LOAD_STATE_LOADED_NORMAL;
      })
      .catch(err => {
        this.loadState = LOAD_STATE_LOADED_ERROR;
        notifier.showError(err, {sender: this});
      });
    },

    // Add open time for new revisions (use time from existing attempts).
    registerNewRevisionsByAttempts() {
      HTTP.post('/levels_revisions/register_new_by_attempts')
      .then(response => {
        const data = response.data.data;
        if(data === null) {
          notifier.showError('Invalid server response. data === null.', {sender: this});
          return;
        }

        const registeredRevisionsAmount = data.registeredRevisionsAmount;
        notifier.showSuccess('registered revisions amount: ' + registeredRevisionsAmount);
      })
      .catch(err => {
        notifier.showError(err, {sender: this});
      });
    },

    updateCache() {
      HTTP.post('/m3/update_level_stat_caches')
      .then(() => {
        //const data = response.data;
        //console.log(data);
        notifier.showSuccess('Caches updated.');
      })
      .catch(err => {
        notifier.showError(err, {sender: this});
      });
    },
  },
};
</script>

<style scoped>
.panel {
  margin-bottom: 1em;
}
</style>
